<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [imageURL]="
              supplier.coverUrl
                ? supplier.coverUrl
                : '/assets/images/default_avatar.jpg'
            "
            [mode]="'avatar'"
            (onClick)="edit(supplier)"
          ></ngx-view-user-display>
        </div>

        <div>
          <a
            *ngIf="supplier?.fullName"
            class="text-body link"
            (onClick)="loadContent(true)"
          >
            <h6>{{ supplier.fullName }}</h6>
          </a>

          <div *ngIf="supplier.tags?.length > 0" class="text-link">
            <ngx-view-tags
              [tags]="supplier.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <button
        *ngIf="mode !== 'dept'"
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + supplier.id"
        (click)="loadButtonAction(supplier)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>

      <h6 *ngIf="mode === 'dept'">
        <span class="text-hint">Hiện tại $:</span>
        <span class="text-primary">
          / Mua: {{ supplier.saleAmount | number }}
        </span>
        <span class="text-success">
          / Trả: {{ supplier.paidAmount | number }}
        </span>
        <span class="text-warning">
          / Nợ: {{ supplier.debitAmount | number }}
        </span>
      </h6>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="content">
      <a
        *ngIf="supplier?.mobile"
        href="tel:{{ supplier.mobile }}"
        class="text-primary link"
      >
        <nb-icon icon="phone-call-outline"></nb-icon> {{ supplier.mobile }}
      </a>

      <a
        *ngIf="supplier?.email"
        href="mailto:{{ supplier.email }}"
        class="text-primary link"
      >
        <nb-icon icon="email-outline"></nb-icon> {{ supplier.email }}
      </a>
    </div>

    <div class="content">
      <a *ngIf="!isMore" (click)="loadContent(true)" class="link text-link">
        <nb-icon icon="chevron-down-outline"></nb-icon>
        Mở rộng
      </a>

      <a
        *ngIf="
          mode === 'dept' &&
          shopService.shop.isArchived &&
          shopService.shop.shopIdArchived &&
          supplier.shopIdArchived &&
          supplier.archivedId !== ''
        "
        (click)="archiveData()"
        class="link text-link"
      >
        <nb-icon icon="calendar-outline"></nb-icon>
        Xem dữ liệu cũ
      </a>
    </div>

    <nb-card *ngIf="isMore">
      <nb-card-body>
        <ul class="detail">
          <li *ngIf="supplier.gender">
            {{ "common.gender" | translate }}:
            <span class="text-hint"> {{ supplier.gender }}</span>
          </li>
          <li *ngIf="supplier.dob">
            {{ "person.dob" | translate }}:
            <span class="text-hint">
              {{ supplier.dob | date: "dd/MM/yyyy" }}</span
            >
          </li>
          <li *ngIf="supplier.cardId">
            CMND: <span class="text-hint"> {{ supplier.cardId }}</span>
          </li>
          <li *ngIf="supplier.tax">
            {{ "person.tax" | translate }}:
            <span class="text-hint"> {{ supplier.tax }}</span>
          </li>
          <li *ngIf="supplier.address">
            {{ "common.address" | translate }}:<span class="text-hint">
              {{ supplier.address }}
            </span>
          </li>
          <li *ngIf="supplier.description">
            {{ "common.note" | translate }}:
            <span class="text-hint" style="white-space: pre">{{
              supplier.description
            }}</span>
          </li>
        </ul>
        <ngx-view-gallery
          *ngIf="supplier.imagesUrl?.length > 0"
          [imagesUrl]="supplier.imagesUrl"
        >
        </ngx-view-gallery>
      </nb-card-body>
    </nb-card>
    <div class="content">
      <a *ngIf="isMore" (click)="loadContent(false)" class="link text-link">
        <nb-icon icon="chevron-up-outline"></nb-icon>
      </a>

      <div *ngIf="isMore" class="button-action">
        <button
          nbButton
          ghost
          status="danger"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="delete(supplier)"
        >
          <nb-icon icon="trash-2-outline"></nb-icon>
        </button>

        <button
          nbButton
          ghost
          status="info"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="edit(supplier)"
        >
          <nb-icon icon="edit-2-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
